import React from 'react';
import { FadeIn } from './FadeIn';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-14 px-4 max-w-4xl mx-auto text-center pt-[0px] pb-[0px]" data-id="element-125">
      <FadeIn data-id="element-126">
        <h2 className="md:text-5xl font-black mb-10 text-transparent bg-clip-text bg-gradient-to-r from-white to-gray-400 text-[28px]" data-id="element-127">
          La próxima campaña puede ser diferente. 🤖
        </h2>

        <div className="space-y-6 max-w-2xl mx-auto mb-10" data-id="element-128">
          {/* Option 1 */}
          <a href="https://tumanualdigital.com/cart/44132276240420:1" className="flex flex-col sm:flex-row items-center justify-between p-6 bg-gray-900 border border-gray-700 rounded-2xl hover:border-gray-500 transition-colors group pt-[0px] pb-[0px]" data-id="element-129">
            <div className="text-left mb-4 sm:mb-0" data-id="element-130">
              <h3 className="font-bold text-xl text-white flex items-center gap-2" data-id="element-131">
                <span data-id="element-132">📘</span> MEGAPACK PROMPTS RENTABLES LISTO
              </h3>
              <p className="text-gray-400 text-sm mb-1" data-id="element-133">
                6 Tomos + 6 Bonos · Todos los niveles
              </p>
              <div className="flex items-center gap-3 mt-1" data-id="element-134">
                <span className="text-red-400 line-through text-sm" data-id="element-135">
                  $97.000
                </span>
                <span className="text-2xl font-black text-white" data-id="element-136">
                  $19.990 ARS
                </span>
              </div>
            </div>
            <div className="bg-gray-800 text-white font-bold py-3 px-6 rounded-xl group-hover:bg-gray-700 transition-colors w-full sm:w-auto text-center" data-id="element-137">
              → QUIERO MI MEGAPACK
            </div>
          </a>

          {/* Option 2 */}
          <a href="https://tumanualdigital.com/cart/44132277616676:1" className="flex flex-col sm:flex-row items-center justify-between p-6 bg-gradient-to-r from-green-900/40 to-gray-900 border-2 border-green-500 rounded-2xl hover:shadow-[0_0_30px_rgba(34,197,94,0.2)] transition-all group relative overflow-hidden" data-id="element-138">
            <div className="absolute top-0 right-0 bg-green-500 text-black text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-139">
              ⭐ MÁS ELEGIDO
            </div>
            <div className="text-left mb-4 sm:mb-0 mt-2 sm:mt-0" data-id="element-140">
              <h3 className="font-bold text-xl text-white flex items-center gap-2" data-id="element-141">
                <span data-id="element-142">🏆</span> MEGAPACK + MÁSTER ESTRATEGA LISTO
              </h3>
              <p className="text-green-400 text-sm mb-1" data-id="element-143">
                6 Tomos + 6 Bonos + Sistema Avanzado
              </p>
              <div className="flex items-center gap-3 mt-1" data-id="element-144">
                <span className="text-red-400 line-through text-sm" data-id="element-145">
                  $140.000
                </span>
                <span className="text-2xl font-black text-green-400" data-id="element-146">
                  $27.990 ARS
                </span>
              </div>
            </div>
            <div className="bg-green-500 text-black font-bold py-3 px-6 rounded-xl group-hover:bg-green-400 transition-colors w-full sm:w-auto text-center shadow-lg" data-id="element-147">
              → QUIERO EL MEGAPACK + MÁSTER ESTRATEGA
            </div>
          </a>
        </div>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-gray-400 font-medium" data-id="element-148">
          <span className="flex items-center gap-1.5" data-id="element-149">
            <Lock size={16} className="text-green-500" data-id="element-150" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-151">
            <Zap size={16} className="text-yellow-400" data-id="element-152" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-1.5" data-id="element-153">
            <Shield size={16} className="text-green-500" data-id="element-154" /> Garantía 7 días
          </span>
        </div>
        <div className="flex flex-wrap justify-center gap-x-4 mt-4 text-sm text-gray-500" data-id="element-155">
          <span className="flex items-center gap-1.5" data-id="element-156">
            <CreditCard size={16} data-id="element-157" /> Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </FadeIn>
    </section>;
}